import { useForm as createUseForm } from "@ant-design-vue/use";
import lodash from "lodash";
import { defineAsyncComponent, reactive, toRaw } from "vue";
import { addModal } from "../../../../../../app.logic";
import {
    createFieldRadioGroup,
    createFieldSelect
} from "../../../../../../components/input/template-builder/template-builder.logic";
import i18n from "../../../../../../i18n";
import { modalStyleForm } from "../../../../../../utils/constant";
import { initUseForm } from "../../../../../../utils/form";
import { createLoading } from "../../../../../../utils/loading";
import { required, requiredWhen, validateError } from "../../../../../../utils/validate";
import { callUserApprove } from "../../../../storage-location/request/modal/confirm-receive.logic";
import { callRequestStatus } from "../../../../storage-location/request/request.section";

export const { isLoading, setIsLoading } = createLoading();

export const ConfirmReceiveForm = defineAsyncComponent(() => import("./ConfirmReceiveForm"));

export const openModalForm = ({ props, onOk, bind }) => {
    const refs = reactive({ form: null });
    const options = addModal({
        bind: lodash.merge(
            lodash.cloneDeep(modalStyleForm),
            {
                okButtonProps: { disabled: false },
                title: i18n.global.t("views.request.modal.receive.title"),
                width: "500px",
                onOk: () => {
                    refs.form.callOnClickModalOk().then(record => {
                        onOk?.(record);
                        options.bind.onCancel();
                    });
                }
            },
            bind
        ),
        render: () => (
            <ConfirmReceiveForm
                ref={e => {
                    if (e) refs.form = e;
                }}
                {...props}
            ></ConfirmReceiveForm>
        )
    });
    return options;
};

export const onClickModalOk = ({ data }) => {
    return data.useForm
        .validate()
        .then(() => ({ ...toRaw(data.useForm.modelRef) }))
        .catch(error => {
            validateError({ error });
            throw error;
        });
};

export const createForm = () => {
    return {
        refStatus: null,
        refToApproveBy: null,
    };
};

export const createRules = ({ data }) => {
    return {
        refStatus: [required],
        refToApproveBy: [requiredWhen({ when: () => ["waitApprove", "waitCompanyAcknowledge"].includes(data.useForm.modelRef.refStatus?.key) })],
    };
};

export const createField = ({ props, data }) => {
    const { useForm } = data;
    const { modelRef } = useForm;
    // const model = props.dataProps?.useForm?.modelRef;
    return [
        createFieldRadioGroup({
            key: "refStatus",
            colProp: () => ({ xs: 24 }),
            formItemProp: () => ({ labelCol: { xs: 24 }, wrapperCol: { xs: 24 } }),
            inputProp: () => {
                return {
                    value: modelRef.refStatus,
                    "onUpdate:value": value => {
                        modelRef.refStatus = value;
                    },
                    list: ({ searchQuery }) =>
                        callRequestStatus({ searchQuery }).then(items => {
                            const result = [];
                            // const samplings = model?.refReleaseTemp?.products?.flatMap(d => d.samplings || []).filter(d => !d.isDelete && !d.isCompanyAcknowledge);
                            // check waitCompanyAcknowledge
                            // if (model?.refRequestType?.key === "1" && model?.refReleaseTemp?.refResult?.key === "3" && samplings.length > 0) {
                            //     const waitCompanyAcknowledge = items.find(item => item.key === "waitCompanyAcknowledge");
                            //     if (waitCompanyAcknowledge) result.push(waitCompanyAcknowledge);
                            // } else {
                            const waitApprove = items.find(item => item.key === "waitApprove");
                            if (waitApprove) result.push(waitApprove);
                            // }
                            return result;
                        }),
                    optLabel: "attribute.actionText",
                    type: "vertical"
                };
            }
        }),
        createFieldSelect({
            key: "refToApproveBy",
            colProp: () => ({ xs: 24 }),
            formItemProp: () => ({ labelCol: { xs: 24 }, wrapperCol: { xs: 24 } }),
            inputProp: () => {
                const disabled = !["waitApprove", "waitCompanyAcknowledge"].includes(modelRef.refStatus?.key);
                if (disabled) {
                    modelRef.refToApproveBy = null;
                }
                return {
                    value: modelRef.refToApproveBy,
                    "onUpdate:value": value => (modelRef.refToApproveBy = value),
                    list: ({ searchQuery }) => callUserApprove({ searchQuery, roleName: props.roleName })
                        .then(data => {
                            if (props?.isShowDepartment && props?.form?.refDepartment?.id) {
                                const dataFilterDepartment = data.filter(d => !d.refDepartment?.id || (d.refDepartment?.id === props?.form?.refDepartment?.id));
                                if (dataFilterDepartment?.length > 0) {
                                    return dataFilterDepartment;
                                }
                            }
                            return data;
                        }),
                    optLabel: "fullNameTh",
                    renderLabel: ({ item }) => {
                        let label = item.fullNameTh;
                        if (props?.isShowDepartment && item.refDepartment?.nameTh) {
                            label += ` (${item.refDepartment?.nameTh})`
                        }
                        return <div>{label}</div>;
                    },
                    placeholder: i18n.global.t("views.request.modal.receive.refToApproveBy"),
                    disabled
                };
            }
        }),
    ];
};

export const loadForm = ({ props, data }) => {
    setIsLoading(true);
    const { form } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    let promise = null;
    if (form) {
        promise = Promise.resolve({ data: [form] });
    } else {
        promise = Promise.resolve({ data: [modelRef] });
    }
    return promise.then(page => initUseForm({ data, page })).finally(() => setIsLoading(false));
};

export const initForm = ({ props, data, refs }) => {
    data.form = createForm({ props, data, refs });
    data.rules = createRules({ props, data, refs });
    data.useForm = createUseForm(data.form, data.rules);
    data.fields = createField({ props, data, refs });
    loadForm({ props, data, refs });
};
